import React from "react";
import {
  Modal,
  Form,
  InputNumber,
  Input,
  Button,
  Select,
  message,
  Spin,
  Divider,
  Transfer,
  Table,
} from "antd";
import { RightOutlined } from "@ant-design/icons";
import * as service from "../service";

const mockData = [];
for (let i = 0; i < 20; i++) {
  mockData.push({
    key: i.toString(),
    title: `content${i + 1}`,
    description: `description of content${i + 1}`,
    disabled: i % 3 < 1,
  });
}

const WarehousingModal = ({ onSubmit, onClose, modalProps, initData }) => {
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  const [tableLoading, changeTableLoading] = React.useState(false);
  const [goods, changeGoods] = React.useState(initData.goods);
  const [visible, changeVisible] = React.useState(true);
  const [currWarehouseId, changeCurrWarehouseId] = React.useState(null);
  const [targetKeys, changeTargetKeys] = React.useState([]);
  const [selectedKeys, changeSelectedKeys] = React.useState([]);
  const [searchParams, changeSearchParams] = React.useState({
    goodsName: "",
    page: 1,
    pageSize: 10,
  });
  const [selectedRows, changeSelectedRows] = React.useState([]);
  const [searchRes, changeSearchRes] = React.useState({
    data: [],
  });
  const [rightData, changeRightData] = React.useState([]);
  React.useEffect(() => {
    getGoodsByActivity();
  }, []);
  React.useEffect(() => {
    console.log("selectedRows", selectedRows);
    console.log("rightData", rightData);
    const newSelectedRows = selectedRows.filter((item) =>
      rightData.every((ele) => ele.goodsId !== item.goodsId)
    );
    console.log("newSelectedRows", newSelectedRows);
    changeSelectedRows(newSelectedRows);
  }, [rightData]);

  const getGoodsByActivity = async () => {
    const res = await service.getGoodsByActivity({ activityId: initData.id });
    if (res.code === 0) {
      changeRightData(res.data);
    }
  };

  const handleSubmit = async () => {
    console.log("rightData", rightData);
    if (rightData.length <= 0) {
      message.error("请勾选商品");
      return;
    }
    const goodsIds = rightData.map((item) => item.goodsId);
    const activityId = initData.id;
    const params = { goodsIds, activityId };
    changeConfirmLoading(true);
    const res = await service.mappingGoods(params);
    changeConfirmLoading(false);
    if (res.data) {
      onSubmit(res);
      message.success("操作成功");
      handleCancel();
    }
  };

  const handleCancel = () => {
    changeVisible(false);
    onClose();
  };
  const onChangeNumber = (record, value) => {
    const newGoods = goods.map((item) => {
      if (item.goodsId === record.goodsId) {
        return {
          ...item,
          count: value,
        };
      }
      return item;
    });
    changeGoods(newGoods);
  };

  const handleDel = (record) => {
    const newRightData = rightData.filter((item) => item.id !== record.id);
    changeRightData(newRightData);
  };
  const handleChange = (nextTargetKeys, direction, moveKeys) => {
    changeTargetKeys(nextTargetKeys);
  };
  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    changeSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  /* 搜索商品 */
  const searchGoods = async (searchParams) => {
    changeTableLoading(true);
    const res = await service.getGoodsRoot({ ...searchParams });
    changeTableLoading(false);
    if (res.data) {
      changeSearchRes({
        ...res.data,
      });
    }
  };
  const toRight = () => {
    changeRightData([...selectedRows, ...rightData]);
  };
  return (
    <Modal
      title="关联商品"
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      {...modalProps}
    >
      <div style={{ display: "flex" }}>
        <div className="left-table">
          <div className="search-box" style={{ height: 35 }}>
            <Input.Search
              placeholder="搜索商品名称、编码、条码"
              style={{ width: 250 }}
              onSearch={(keywords) => {
                const newSearchParams = {
                  ...searchParams,
                  goodsName: keywords,
                };
                changeSearchParams(newSearchParams);
                searchGoods(newSearchParams);
              }}
            />
          </div>
          <Table
            dataSource={searchRes.data.map((item) => ({
              ...item,
              goodsId: item.id,
            }))}
            loading={tableLoading}
            columns={[
              {
                title: "商品名称",
                dataIndex: "goodsName",
                width: 150,
              },
              {
                title: "商品编号",
                dataIndex: "indexCode",
                width: 150,
              },
              {
                title: "商品条码",
                dataIndex: "goodsCode",
                width: 150,
                render: (text, record) => (
                  <div>
                    {(record.codes || []).map((item, index) =>
                      index > 0 ? `、${item.goodsCode}` : item.goodsCode
                    )}
                  </div>
                ),
              },
            ]}
            bordered
            rowKey="goodsId"
            rowSelection={{
              type: "checkbox",
              selectedRowKeys: selectedRows.map((item) => item.goodsId),
              onChange: (selectedRowKeys, selectedRows) => {
                changeSelectedRows(selectedRows);
              },
              getCheckboxProps: (record) => ({
                disabled: rightData.some(
                  (item) => item.goodsId === record.goodsId
                ),
                // name: record.name,
              }),
            }}
            onRow={(record) => {
              return {
                // onClick: (event) => {
                //   let newSelectedRows = [];
                //   const curr = selectedRows.find(
                //     (item) => item.id === record.id
                //   );
                //   if (curr) {
                //     newSelectedRows = selectedRows.filter(
                //       (item) => item.id !== curr.id
                //     );
                //   } else {
                //     newSelectedRows = [...selectedRows, record];
                //   }
                //   changeSelectedRows(newSelectedRows);
                // }, // 点击行
              };
            }}
            size="small"
            pagination={{
              showQuickJumper: true,
              current: searchRes.page,
              pageSize: searchRes.pageSize,
              total: searchRes.total,
              onChange: (_page, _pageSize) => {
                const newParams = {
                  ...searchParams,
                  page: _page,
                  pageSize: _pageSize,
                };
                changeSearchParams(newParams);
                searchGoods(newParams);
              },
              showTotal: (total, range) => `总共 ${total} 条`,
              pageSizeOptions: [10, 20, 50, 100],
              showSizeChanger: true,
            }}
          />
        </div>
        <div
          className="btn-box"
          style={{
            margin: "0 15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            size="small"
            type="primary"
            disabled={selectedRows.length === 0}
            onClick={toRight}
          >
            <RightOutlined />
          </Button>
        </div>
        <div className="right-table">
          <div className="search-box" style={{ height: 35 }}>
            {/* <Input.Search
              placeholder="搜索商品名称、编码、条码"
              style={{ width: 250, marginBottom: 5 }}
            /> */}
          </div>
          <Table
            dataSource={rightData}
            columns={[
              {
                title: "商品名称",
                dataIndex: "goodsName",
                width: 150,
              },
              {
                title: "商品编号",
                dataIndex: "indexCode",
                width: 150,
              },
              {
                title: "商品条码",
                dataIndex: "goodsCode",
                width: 150,
                render: (text, record) => (
                  <div>
                    {(record.codes || []).map((item, index) =>
                      index > 0 ? `、${item.goodsCode}` : item.goodsCode
                    )}
                  </div>
                ),
              },
              {
                title: "操作",
                width: 150,
                render: (text, record) => (
                  <div>
                    <a
                      style={{ color: "orangered" }}
                      onClick={handleDel.bind(this, record)}
                    >
                      删除
                    </a>
                  </div>
                ),
              },
            ]}
            bordered
            rowKey="goodsId"
            size="small"
          />
        </div>
      </div>
    </Modal>
  );
};

export default WarehousingModal;
